// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

//var $ = require('jquery');
var Menu = require('../_modules/main_nav/main_nav');
var Toolbar = require('../_modules/toolbar/toolbar');
var Card = require('../_modules/card/card');
var Apps = require('../_modules/applications/applications');
var Accordions = require('../_modules/accordion/accordion');
var Links = require('../_modules/links/links');

$(function () {

	new Menu();
	new Toolbar();
	new Card();
	new Apps();
	new Accordions();
	new Links();

	//selectbox in upload file page, remove the checkbox
	$(document).ready(function() {
		var selectValue = $('#p_lt_ctl01_pageplaceholder_p_lt_ctl01_pageplaceholder_p_lt_ctl01_CevnTwoColumnLayout_CevnTwoColumnLayout_Center_WebPartZone_WebPartZone_zone_CevnFileUploadUtility_DocumentTypes').val();
		if(	selectValue != "1"){
			$('.card_item.checkbox').hide();
		}
		
		var hash = window.location.hash;
		if(hash != "") {
			var id = hash.substr(1);
			if ( document.getElementById(id) && document.getElementById(id).parentElement.parentElement.className == 'accordion-content-area')
			{
				document.getElementById(id).parentElement.nextElementSibling.style.display = 'block'			
			}
		}
	})

	//var $base = 'http://cevn.local'; 		// TEST
	var $base = window.location.origin;	// LIVE

	// favourites
	var $favURL = $base + "/API/widgets/tilesFavourites";

	$('html').removeClass('no-js');

	if ($('.card_favourites').length > 0) {

		var $favIDs = [];

		$('.my_favourites_delete').on('click', function () {
			var $id = Number($(this).attr('id'));
			$(this).parent('li').remove();
			$favIDs.push($id);
		})

		$('.my_favourites_edit').on('click', function () {
			var edit = $(this).hasClass('edit');

			if (edit == true) {
				$(this).removeClass("edit").addClass("done");
				$(this).find('a').attr('class', 'icomoon-done');
				$(this).find('span').text('Done');
				$('.my_favourites_items li').addClass('edit');
			} else {
				$.ajax({
					url: $favURL,
					type: 'DELETE',
					dataType: 'json',
					data: JSON.stringify($favIDs),
					contentType: "application/json; charset=utf-8",
					success: function (data) {
						$('.my_favourites_edit').removeClass("done").addClass("edit");
						$('.my_favourites_edit').find('a').attr('class', 'icomoon-edit');
						$('.my_favourites_edit').find('span').text('Edit');
						$('.my_favourites_items li').removeClass('edit');
					}
				});
			}
		})
	}

	$('.addfav').on('click', function () {
		var $this = $(this);
		var $pageTitle = $this.parent().data('title');

		var $html = '';

		$.ajax({
			method: "GET",
			url: $favURL,
			success: function (data) {
				var $noFav = data.favourites.length

				if ($noFav < 12) {

					$html = '<div class="addfav_modal">' +
						'<div>' +
						'<p>' +
						'<label>Title</label>' +
						'<input id="title" type="text" value="' + $pageTitle + '">' +
						'</p>' +
						'<p>' +
						'<label>Icon</label>' +
						'<select>' +
						'<option value="icomoon-todo">To do</option>' +
						'<option value="icomoon-legal">Legal</option>' +
						'<option value="icomoon-sys">System</option>' +
						'<option value="icomoon-data">Database</option>' +
						'<option value="icomoon-folder">Folder</option>' +
						'<option value="icomoon-info">Information</option>' +
						'<option value="icomoon-apps">Browser window</option>' +
						'</select>' +
						'</p>' +
						'<div class="addfav_buttons">' +
						'<button id="save-btn" class="btn-green">Save</button>' +
						'<button id="cancel-btn" class="btn-red">Cancel</button>' +
						'</div>' +
						'</div>' +
						'</div>'
				} else {
					$html = '<div class="addfav_modal">' +
						'<div>' +
						'<p class="error_msg">Your favourites list is full</p>' +
						'<div class="addfav_buttons">' +
						'<button id="cancel-btn" class="btn-red">OK</button>' +
						'</div>' +
						'</div>' +
						'</div>'
				}
				$this.append($html);
			}
		});
	})

	$('.addfav').on('click', '#cancel-btn', function (e) {
		$(this).parents(':eq(4)').find('.addfav_modal').remove();
		e.stopPropagation();
	});

	$('.addfav').on('click', '#save-btn', function (e) {
		var $details = $(this).parents(':eq(4)'),
			$title = $details.parents(':eq(2)').find('#title').val(),
			$link = $details.data('url'),
			$icon = $(this).parents(':eq(2)').find('select').val();

		var $data = '{"title":"' + $title + '","icon":"' + $icon + '","link":"' + $link + '"}';

		$.ajax({ // GET all saved forms and put them into a list
			method: "POST",
			url: $favURL,
			data: $data,
			contentType: "application/json; charset=utf-8",
			success: function () {
				$(this).parents(':eq(4)').find('.addfav_modal').remove();
			}
		});
		e.stopPropagation();
	});

	$('.addfav').on('click', '#title', function (e) {
		$(this).val('').focus();
		e.stopPropagation();
	});

	$('.addfav').on('click', 'select', function (e) {
		$(this).focus();
		e.stopPropagation();
	});

	if ($('.card_data').length > 0) {

		if ($('.card_selector option').length == 1) {
			$('.card_selector').attr("disabled", "disabled");
		};

		var $btnURL = $('.card_data .btn-red.viewall').attr('href');
		var $newURL = $btnURL + '?eNum=' + $('.card_selector').val();
		$('.card_data .btn-red.viewall').attr('href', $newURL)

		//console.log($newURL)

		$('.card_selector').change(function () {
			var $eNum = $(this).val(),
				$url = $base + '/api/widgets/tilesdataandsurvey?take=5&eNumber=' + $eNum;

			$newURL = $btnURL + '?eNum=' + $('.card_selector').val();
			$('.card_data .btn-red.viewall').attr('href', $newURL)

			//console.log($newURL)
			loadCard($url);
			//loadCard('/api/esample.json');
		})

		function loadCard($url) {
			$.ajax({
				method: "GET",
				url: $url,
				success: function (data) {
					var $html = "";

					for (var i = 0; (i < data.SchoolDataAndSurvey.length) && (i < 5); i++) {

						var section = data.SchoolDataAndSurvey[i]
						$html += '<div class="card_item card_item-' + section.StatusDescription + ' data-colour="' + section.StatusColourHex + '">' +
							'<div class="row">' +
							'<div class="two-third">' +
							'<a class="card_item_link" href="' + section.URL + '">' +
							'<p>' + section.Title + '</p>' +
							'<span class="message">' + section.Message + '</span>' +
							'</a>' +
							'</div>' +
							'<div class="third">' +
							'<div class="card_row">' +
							'<span class="status half">' + section.StatusDescription + '</span>' +
							'<span class="due half">' + section.DateDueFormatted + '</span>' +
							'</div>' +
							'</div>' +
							'</div>' +
							'</div>'
					}

					$('.card_data .container').html($html);

				}
			});
		}
	}

	if ($('#dataNotification').length > 0) {
		// data and survey subscription

		var $notificationStatus = false;
		var $noticeOn = $('#dataNotification').data('notification-true');
		var $noticeOff = $('#dataNotification').data('notification-false');

		var $dataNotificationURL = $base + '/api/widgets/tilesdataandsurvey/subscribe';

		$.ajax({ // GET all saved forms and put them into a list
			method: "POST",
			url: $dataNotificationURL,
			success: function (data) {
				//var $data = $('#dataNotification').data('subscription');
				//console.log(data);

				if (data == true) {
					$('#dataNotification').text($noticeOn);
					$notificationStatus = true;
				} else {
					$('#dataNotification').text($noticeOff);
					$notificationStatus = false;
				}
			}
		});

		$("#dataNotification").on('click', function () {

			if ($notificationStatus == true) {

				$.ajax({
					"async": true,
					"crossDomain": true,
					"url": $dataNotificationURL,
					"method": "POST",
					"headers": {
						"content-type": "application/json",
						"cache-control": "no-cache"
					},
					"processData": false,
					"data": "false"
				}).done(function (response) {
					// if(response){
					// 	 console.log('You are subscribed');
					// } else {
					// 	console.log('You are NOT subscribed');
					// }
				});

				$notificationStatus = false
				$('#dataNotification').text($noticeOff);

			} else {

				$.ajax({
					"async": true,
					"crossDomain": true,
					"url": $dataNotificationURL,
					"method": "POST",
					"headers": {
						"content-type": "application/json",
						"cache-control": "no-cache"
					},
					"processData": false,
					"data": "true"
				}).done(function (response) {

				});

				$notificationStatus = true
				$('#dataNotification').text($noticeOn);
			}
		});
	}

	if ($('#data-survey').length > 0) {

		var $url,
			$skip = 0,
			$take = 10,
			$status = ($('.data_filters input[type=radio]:checked').val() == "null") ? '' : '&StatusID=' + $('.data_filters input[type=radio]:checked').val(),
			$date = $('#date-picker').val(),
			$daterange = ($('#date-picker').val() == ('No range set' || '')) ? '' : '&dateDue=' + $('#date-picker').val().replace(/[/]/g, "%2F"),
			$eNum = (getParameterByName("eNum") == null) ? '' : '&eNumber=' + getParameterByName("eNum"),
			$title = '',
			$url = $base + '/api/widgets/tilesdataandsurvey' + '?skip=' + $skip + '&take=' + $take + $eNum + $status + $daterange;

		console.log($url);

		if ($date == '') {
			$('#date-picker').val('No range set');
		}

		// Load first page of data and survey
		loadData(0, 10, $url);

		$("input[type=radio]").on('click', function () {
			$status = $(this).val();
			$title = $(this).attr('id') + ' ';
		})

		// Do a new search for data and survey
		$('.data_filters .search_submit').on('click', function (e) {
			// reset to first page
			$skip = 0;
			$take = 10;
			$date = $('#date-picker').val();
			$status = ($('.data_filters input[type=radio]:checked').val() == "null") ? '' : '&StatusID=' + $('.data_filters input[type=radio]:checked').val(),
				$daterange = ($('#date-picker').val() == ('No range set' || '')) ? '' : '&dateDue=' + $('#date-picker').val().replace(/[/]/g, "%2F"),
				$eNum = ($('#school_eNum').val() == '') ? '' : '&eNumber=' + $('#school_eNum').val(),
				$url = $base + '/api/widgets/tilesdataandsurvey' + '?skip=' + $skip + '&take=' + $take + $eNum + $status + $daterange;
			//console.log($daterange);
			loadData($skip, $take, $url);
			e.preventDefault;
		})

		// Create data and survey list
		function loadData($skip, $take, $url) {

			$.ajax({
				method: "GET",
				url: $url,
				success: function (data) {
					var $html = "", $results;
					var $current = 1 + Math.round($skip / 10),
						$last = Math.ceil(data.CountPostFilter / 10);


					// update results found text
					if (data.CountPostFilter > 10) {
						if ((Number($skip) + Number($take)) > data.CountPostFilter) {
							$results = 'Showing ' + (Number($skip) + 1) + '-' + data.CountPostFilter + ' of ' + data.CountPostFilter + ' results';
						} else {
							$results = 'Showing ' + (Number($skip) + 1) + '-' + (Number($skip) + Number($take)) + ' of ' + data.CountPostFilter + ' results';
						}

					} else if (data.CountPostFilter > 0) {
						$results = 'Showing ' + data.CountPostFilter + ' result(s)';
					} else {
						$results = 'No results found. Try a wider search by adjusting the filters.';
					}

					$('#data-survey h3').text('You are viewing all ' + $title + 'Data and Surveys listed');

					$('.results').text($results);

					if ($('.data-list').html() != '') { $('.data-list').html('') }

					$('span.pagination_page').text('Page ' + $current + ' of ' + $last);
					//$('.card_pagination .current').text($current);
					//$('.card_pagination .last').text($last);
					$('.card_pagination .last_item').text($last);

					pag($current, $last);

					for (var i = 0; (i < data.SchoolDataAndSurvey.length) && (i < 10); i++) {

						var section = data.SchoolDataAndSurvey[i]

						$html = '<div class="card_item item_list ' + section.StatusDescription + '">' +
							'<div class="title-row">' +
							'<div>' +
							'</div>' +
							'<div><a href="' + section.URL + '" class="item_list_link">' + section.Title + '</a><a href="' + section.URL + '" class="item_list_link">' + section.URL + '</a></div>' +
							'</div>' +
							'<div class="row"><span class="item_list_published">Due <span>' + section.DateDueFormatted + '</span></span>' +
							'<p class="item_list_blurb">' + section.Message + '</p>' +
							'</div>' +
							'</div>'

						$('.data-list').append($html);
					}
				}
			});
		}

		$('.pagination').on('click', '.pagination_item', function () {
			$('html,body').scrollTop(0);
			var $skip = $(this).data('skip');
			var $take = '10';
			var $status = $('.data_filters input[type=radio]:checked').val();

			var $url = $base + '/api/widgets/tilesdataandsurvey' + '?skip=' + $skip + '&take=' + $take + '&StatusID=' + $status;

			loadData($skip, $take, $url);
		})

		function pag(current, pages) {
			var $html = '';

			if (pages <= 1) {
				$('.card_pagination').hide();
				return false;
			} else if (pages < 7) { //(0)
				$('.card_pagination').show();
				// If there are less than 7 pages - pagination style 1 to 7
				for (var i = 0; i < pages; i++) {

					if (i == (current - 1)) { // hightlight the current page Number
						$html += '<span class="pagination_item current" data-skip="' + (i * 10) + '">' + (i + 1) + '</span>';
					} else { // skip the next 10 results with each page forward
						$html += '<a class="pagination_item" href="javascript:void(0)" data-skip="' + (i * 10) + '">' + (i + 1) + '</a>';
					}
				}// build pagination
				$('.pagination').html($html);
			} else if (current >= 5) { //(2)
				$('.card_pagination').show();
				// If more than 7 pages AND
				// when the user clicks on page 5 OR above,
				// example pagination style 1 ... 3 to 7 ... 50

				$html += '<a class="pagination_item" href="javascript:void(0)" data-skip="0">' + 1 + '</a><span class="pagination_item"> ... </span>';

				if (current > (pages - 4)) { //(4)
					// Once the user has reached the last 7
					// pagination style - first ... num num num num last
					for (var i = (pages - 5); i < pages; i++) {
						if (i == (current - 1)) {
							$html += '<span class="pagination_item current" data-skip="' + (i * 10) + '">' + (i + 1) + '</span>';
						} else {
							$html += '<a class="pagination_item" href="javascript:void(0)" data-skip="' + (i * 10) + '">' + (i + 1) + '</a>';
						}
					}
				} else { //(3)
					// Somewhere in the middle - more than first 5 and less than last 5
					// pagination style - first ... num num current num num ... last
					for (var i = (current - 2); i < (current + 3); i++) {
						if (i == current) {
							$html += '<span class="pagination_item current" data-skip="' + ((i - 1) * 10) + '">' + i + '</span>';
						} else {
							$html += '<a class="pagination_item" href="javascript:void(0)" data-skip="' + ((i - 1) * 10) + '">' + i + '</a>';
						}
					}
					$html += '<span class="pagination_item"> ... </span>'
					$html += '<a class="pagination_item" href="javascript:void(0)" data-skip="' + ((pages - 1) * 10) + '">' + pages + '</a>';
				}
				$('.pagination').html($html);

			} else { // (1)
				$('.card_pagination').show();
				// If more than 7 pages AND
				// the user is below page 5
				// pagination 1 to 5 ... last
				for (var i = 1; i < 6; i++) {
					if (i == current) {
						$html += '<span class="pagination_item current" data-skip="' + ((i - 1) * 10) + '">' + i + '</span>';
					} else {
						$html += '<a class="pagination_item" href="javascript:void(0)" data-skip="' + ((i - 1) * 10) + '">' + i + '</a>';
					}
				}
				$html += '<span class="pagination_item"> ... </span><a class="pagination_item" href="javascript:void(0)" data-skip="' + ((pages - 1) * 10) + '">' + pages + '</a>';
				$('.pagination').html($html);
			}
		}
	}

	function paginationButtons() {

		var query_string = location.search;
		function getURLParameter(name) {
			return decodeURIComponent(
				(RegExp('[?|&]'+name + '=' + '(.+?)(&|$)').exec(location.search)||[null,null])[1]
			);
		}
		var page = getURLParameter("page");
		var oldPara = "page=" + page;
		var previousPage = +page - 1;
		var nextPage = +page + 1;


		if (page == 1 || page=="null") {
			$('.pagination_item.previous').hide();
		}

		$('.pagination_item.previous').on('click', function () {
			var newPara = "page=" + previousPage;
			location.search = query_string.replace(oldPara, newPara);
		})
		
		$('.pagination_item.next').on('click', function () {
			if (page=="null") {
				location.search = query_string + "&page=2";
			  } else {
				var newPara = "page=" + nextPage;
				location.search = query_string.replace(oldPara, newPara);
			}
		})
	} paginationButtons()

	$('input[required]').on('focus', function () {
		$(this).prev('.error_message').text('')
	})

	$('input[required]').on('blur', function () {
		var $this = $(this).val();

		if ($this == '') {
			$(this).addClass('empty');
			$(this).prev('.error_message').text('This field can not be empty.')
		} else {
			$(this).removeClass('empty');
		}
	})
	$('.icomoon-uploadfile').on('click', function () {
		$(this).prev('input').click();
	})
	$('.inputfile').each(function () {
		var $input = $(this),
			$label = $input.parent().find('label.fileName');

		$input.on('change', function (e) {
			var fileName = '';
			var fileTypeSelector = $('#p_lt_ctl01_pageplaceholder_p_lt_ctl01_pageplaceholder_p_lt_ctl01_CevnTwoColumnLayout_CevnTwoColumnLayout_Center_WebPartZone_WebPartZone_zone_CevnFileUploadUtility_FileTypes')


			if (this.files && this.files.length > 1)
				fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
			else if (e.target.value)
				fileName = e.target.value.split('\\').pop();

			if (fileName)
				$label.html(fileName);
			else
				$label.html('No file selcted');

			if ($('.success_message') != null) {
				$('.success_message').html('');
				$('.success_message').removeClass('success_message');
				$('.icomoon-uploadfile').removeClass('error');
			}
			if ($('.error_message') != null) {
				$('.error_message').html('');
				$('.error_message').removeClass('error_message');
				$('.icomoon-uploadfile').removeClass('error');
				$(fileTypeSelector).parents('.two-third').removeClass('error-icon')
			}
		});
		var fileIcon = '<span class="file-icon"></span>';
		var errorLabel = $('#p_lt_ctl01_pageplaceholder_p_lt_ctl01_pageplaceholder_p_lt_ctl01_CevnTwoColumnLayout_CevnTwoColumnLayout_Center_WebPartZone_WebPartZone_zone_CevnFileUploadUtility_Message')
		var fileTypeSelector = $('#p_lt_ctl01_pageplaceholder_p_lt_ctl01_pageplaceholder_p_lt_ctl01_CevnTwoColumnLayout_CevnTwoColumnLayout_Center_WebPartZone_WebPartZone_zone_CevnFileUploadUtility_FileTypes')

		$('.icomoon-uploadfile').append(fileIcon)

		if (!$(errorLabel).is(':empty')) {
			$('.icomoon-uploadfile').addClass('error');
		} 
		if ($(errorLabel).html() === "Incorrect File Type Selected") {
			$(fileTypeSelector).parents('.two-third').addClass('error-icon')
		} 
		if ($('.success_message').html() === "File Successfully Uploaded.") {
			$('.icomoon-uploadfile').removeClass('error');
		}

		// Firefox bug fix
		$input
			.on('focus', function () { $input.addClass('has-focus'); })
			.on('blur', function () { $input.removeClass('has-focus'); });
	});

	// For prototype demo ONLY - remove for build
	var $page = $('.page_breadcrumbs li:nth-child(2) a').text();

	switch ($page) {
		case 'Finance':
			$('.finance').addClass('current');
			break;
		case 'Curriculum':
			$('.curriculum').addClass('current');
			break;
		default:
			break;
	}

  var $dismiss_cookie_name = window.location.pathname.replaceAll('/', '_');
	// 10 years in seconds (60*60*24*365*10)
	// var $dismiss_cookie = $dismiss_cookie_name + '=1; Max-age=315360000';
	// Dismiss time of one day
	var $dismiss_cookie = $dismiss_cookie_name + '=1; Max-age=86400';

  var disclaimerReuse = ['Critical-Incident-Management'];

  disclaimerReuse.every(element => {

    if ($dismiss_cookie_name.includes(element)) {
      if (document.cookie.includes(element)) {
        $('.modal').hide();
        return false;
      }
      else {
        $('.modal').show();
        return false;
      }

    }
    else {
      if (document.cookie.indexOf($dismiss_cookie_name) == -1) {
        $('.modal').show();
        return false;
      } else {
        $('.modal').hide();
        return false;
      }
    }


  });

	// disclaimer cookie
	// if (document.cookie.indexOf($dismiss_cookie_name) == -1) {
		// $('.modal').show();
	// } else {
		// $('.modal').hide();
	// }

	//modal
	$('.agree').on('click', function () {
		document.cookie = $dismiss_cookie;
		$('.modal').hide();
	})

	$('main.page .page_article a').on('click', function () {
		$(this).addClass('visited')
	})

	// ---------------------------------//
	//           SEARCH START           //
	//---------------------------------//
	$('.advance-filters').on('click', function () {
		$('.hide').removeClass('hide');
		$(this).addClass('hide');
	})

	// Quick basic search
	$('.basic-search .search_submit').on('click', function (e) {
		var $keyword = $(this).prev('input[name="keyword"]').val(),
			$url = $(this).parent().data('url');
		var $diocese = $(this).parent().data('diocese');

		if ($keyword != undefined) {
			window.location = $url + "keyword=" + $keyword + "&category=All" + "&sort=Relevance" + "&type=0" + "&diocese=" + $diocese + "&page=1";
		} else {
			window.location = $url;
		}
		e.preventDefault();
	});

	$('.basic-search input, .full-search input').on('keydown', function (e) {
		if (e.keyCode === 13) {
			$(this).next().trigger('click');
			e.preventDefault();
		}
	});

	// full search
	$('.full-search .search_submit').on('click', function (e) {
		$('.search_filters .search_submit').trigger('click');
		e.preventDefault();
	})

	// Full Search
	$('.search_filters .search_submit').on('click', function (e) {

		var $searchString = $('.search_filters').data('url'),
			$keyword = $('.full-search .search_submit').prev('#keyword').val(),
			$category = $('input[type="radio"]:checked').val(),
			$school = $('#school').val(),
			$sort = $('#sort').val(),
			$type = $('#type').val(),
			$diocese = $('#diocese').val(),
			$date = $('#date-picker').val(),
			$daterange = $('#date-picker').val().replace(/[/]/g, "%2F");

		if ($keyword != undefined) {
			$searchString += "keyword=" + $keyword
		}
		if ($category != undefined) {
			$searchString += "&category=" + $category
		}
		if ($school != undefined) {
			$searchString += "&school=" + $school
		}
		if ($sort != undefined) {
			$searchString += "&sort=" + $sort
		}
		if ($type != undefined) {
			$searchString += "&type=" + $type
		}
		if ($diocese != undefined) {
			$searchString += "&diocese=" + $diocese
		}
		if ($daterange != 'No range set') {
			$searchString += "&date=" + $daterange
		}

		//console.log($searchString);
		window.location = $searchString;

		e.preventDefault();

	});

	// Add basic search value to input
	if ($('.search_filters').length != 0) {

		var $school = getParameterByName("school"),
			$sort = getParameterByName("sort"),
			$type = getParameterByName("type"),
			$diocese = getParameterByName("diocese"),
			$date = getParameterByName("date");

		$('.full-search input').val(getParameterByName("keyword"));
		$('input:radio[value="' + getParameterByName("category") + '"]').prop('checked', true);

		if ($school != null) { $('#school').val($school) }
		if ($sort != null) { $('#sort').val($sort) }
		if ($type != null) { $('#type').val($type) }
		if ($diocese != null) { $('#diocese').val($diocese) }
		if ($date == null) {
			$('#date-picker').val('No range set');
		} else {
			$('#date-picker').val($date);
		}

		//highlight search result
		var text = $('.search_dark input').val();
		if (text.length > 0) {
			var re = new RegExp('(' + text + ')', 'gi');
			$("a.item_list_link").each(function () {
				$(this).html($(this).html().replace(re, '<span class="search-highlight">$1</span>'));
			});

			$("p.item_list_blurb").each(function () {
				$(this).html($(this).html().replace(re, '<span class="search-highlight">$1</span>'));
			});
		}
	}

	function getParameterByName(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}

	// clear filters button
	$('.clear-filters').on("click", function () {
		$('input:checkbox').prop('checked', false);
		$('input:radio').prop('checked', false);
		$('input:radio[value="null"]').prop('checked', true);
		$('input:radio[value="all"]').prop('checked', true);
		$('select').prop('selectedIndex', 0);
		$('#date-picker').val('No range set');
	})

	$('#date-picker').daterangepicker({
		// "startDate": moment().subtract(30, 'days'),
		// "endDate": moment(),
		"autoUpdateInput": false,
		"locale": {
			"format": "DD/MM/YYYY",
			"cancelLabel": "Clear"
		}
	});

	$('#date-picker').on('apply.daterangepicker', function (ev, picker) {
		$(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));

	});
	$('#date-picker').on('cancel.daterangepicker', function (ev, picker) {
		$(this).val('No range set');
	});

	//Check if mobile
	var isMobile = false; //initiate as false
	// device detection
	if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
		|| /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
		isMobile = true;
	}
	//make search filters collapsible on mobile
	if ($(window).width() < 767) {
		var $filterArrow = $('.search_filters .card_header'),
			$filterCards = $('.search_filters .card_item');

		$('.search_filters').addClass('collapse');
		$filterArrow.addClass('active');
		$filterCards.addClass('hide-me');

		$filterArrow.on('click', function () {
			if ($filterArrow.hasClass('active')) {
				$(this).removeClass('active');
				$filterCards.removeClass('hide-me');
			}
			else {
				$(this).addClass('active');
				$filterCards.addClass('hide-me');
			}
		})
	}

	// ---------------------------------//
	//           SEARCH END           //
	//---------------------------------//

	//Sticky polyfill
	var stickyElm = $(document).find('.sticky');
	if (stickyElm.length > 0) {
		var elements = $('.sticky');
		Stickyfill.add(elements);
	}


	$('.page_nav_title').on('click', function () {
		var isOpen = $(this).parent().hasClass('active');
		isOpen === true ? $(this).parent().removeClass('active') : $(this).parent().addClass('active');
	});

	$('.page_nav.collapsible > ul').addClass('level-2')
	$('.page_nav.collapsible > ul > li > ul').addClass('level-3')
	$('.page_nav.collapsible > ul > li > ul > li > ul').addClass('level-4');
	$('.Highlighted').parent('ul').parent('nav').addClass('active');
	$('.Highlighted').parent('ul').parent('li').addClass('active');


	$('.level-3, .level-4').each(function () {
		$(this).parent().addClass('haschild').append('<a class="menu_toggle"><span class="sr-only">Open sub-menu</span></a>');
	})

	$(document).on('click', '.level-2 > li > .menu_toggle', function () {
		var isOpen = $(this).parent().hasClass('active');

		if (isOpen === true) {
			$(this).parent().removeClass('active')
		} else {
			$('.level-2 > .active').removeClass('active');
			$(this).parent().addClass('active');
		}
	});

	$(document).on('click', '.level-3 li .menu_toggle', function () {
		var isOpen = $(this).parent().hasClass('active');
		isOpen === true ? $(this).parent().removeClass('active') : $(this).parent().addClass('active');
	});

	//make side menu parent item expand when clicking it to the landing page
	$('.page_nav.collapsible li').each(function () {
		if ($(this).hasClass('Highlighted') && $(this).hasClass('haschild')) {
			$(this).addClass('active')
		}
	})

	// New accordion
	$('.new-accordion a').on('click', function(){
		$(this).next('.body').slideToggle()
		if($(this).attr('aria-expanded') === 'true'){
			$(this).attr('aria-expanded', 'false')	
		}else{
			$(this).attr('aria-expanded', 'true')
		}
	})

	$('.accordion-group .collapse-button').on('click', function(){
		if($(this).attr('aria-expanded') === 'true'){
			$(this).attr('aria-expanded', 'false')
			$('.new-accordion a').attr('aria-expanded', 'false')
			$('.new-accordion .body').slideUp()
			$(this).text('Expand All')
		}else{
			$(this).attr('aria-expanded', 'true')
			$('.new-accordion a').attr('aria-expanded', 'true')
			$('.new-accordion .body').slideDown()
			$(this).text('Collapse All')
		}
	})
});
